<template>
  <div>
    <div class="row geoinformation_solution">
      <div class="geoinformation_solution-text">
        <div class="row">
          <div class="geoinformation_solution-title">
            <span is="i18n">
              <span lang="ru">Казахстанские Географические Информационные Системы</span>
              <span lang="en">Kazakhstan Geographical Information Systems</span>
              <span lang="kk">Қазақстандық Географиялық Ақпараттық Жүйелер</span>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="geoinformation_solution-subtext">
            <span is="i18n">
              <span lang="ru">
                Казахстанское агентство географических информационных систем и дистанционного
                зондирования
              </span>
              <span lang="en">
                Kazakhstan Agency for geographical information systems and remote sensing
              </span>
              <span lang="kk">
                Қазақстандық географиялық ақпараттық жүйелер және қашықтықтан зондтау агенттігі
              </span>
            </span>
          </div>
        </div>
        <div class="row">
          <router-link to="/contacts" class="btn contact_button">
            <span is="i18n">
              <span lang="ru">Связаться</span>
              <span lang="en">Contact</span>
              <span lang="kk">Байланысу</span>
            </span>
          </router-link>
        </div>
      </div>
      <div class="geoinformation_solution-map">
        <img src="@/assets/images/Triangle_map.svg" alt="Map" />
      </div>
    </div>
    <div class="main_cards">
      <div class="row">
        <div class="main_card">
          <div class="main_card-container">
            <div class="main_card-image">
              <img src="@/assets/images/about_us.svg" alt="" />
            </div>
            <div class="main_card-title">
              <span is="i18n">
                <span lang="ru">О нас</span>
                <span lang="en">About us</span>
                <span lang="kk">Біз туралы</span>
              </span>
            </div>
            <div class="main_card-text">
              <span>established 2008 </span>
            </div>
            <router-link to="/about" class="main_card-link">
              <span is="i18n">
                <span lang="ru">Перейти</span>
                <span lang="en">Go</span>
                <span lang="kk">Өту</span>
              </span>
              <i class="icon arrow-right"></i>
            </router-link>
          </div>
        </div>
        <div class="main_card">
          <div class="main_card-container">
            <div class="main_card-image">
              <img src="@/assets/images/partners.svg" alt="" />
            </div>
            <div class="main_card-title">
              <span is="i18n">
                <span lang="ru">Партнеры</span>
                <span lang="en">Partners</span>
                <span lang="kk">Серіктестер</span>
              </span>
            </div>
            <div class="main_card-text">
              <span is="i18n">
                <span lang="ru">Lorem ipsum dolor sit amet consectetur adipisicing.</span>
                <span lang="en">Lorem ipsum dolor sit amet consectetur adipisicing.</span>
                <span lang="kk">Lorem ipsum dolor sit amet consectetur adipisicing.</span>
              </span>
            </div>
            <router-link to="/partners" class="main_card-link">
              <span is="i18n">
                <span lang="ru">Перейти</span>
                <span lang="en">Go</span>
                <span lang="kk">Өту</span>
              </span>
              <i class="icon arrow-right"></i>
            </router-link>
          </div>
        </div>
        <div class="main_card">
          <div class="main_card-container">
            <div class="main_card-image">
              <img src="@/assets/images/career.svg" alt="" />
            </div>
            <div class="main_card-title">
              <span is="i18n">
                <span lang="ru">Карьера</span>
                <span lang="en">Career</span>
                <span lang="kk">Мансап</span>
              </span>
            </div>
            <div class="main_card-text">
              <span is="i18n">
                <span lang="ru">Постройте Ваши ключевые навыки в нашей команде</span>
                <span lang="en">Develop your key skills in our team</span>
                <span lang="kk"
                  >Біздің командада өзіңіздің негізгі дағдыларыңызды қалыптастырыңыз</span
                >
              </span>
            </div>
            <router-link to="/career" class="main_card-link">
              <span is="i18n">
                <span lang="ru">Перейти</span>
                <span lang="en">Go</span>
                <span lang="kk">Өту</span>
              </span>
              <i class="icon arrow-right"></i>
            </router-link>
          </div>
        </div>
        <div class="main_card">
          <div class="main_card-container">
            <div class="main_card-image">
              <img src="@/assets/images/contacts.svg" alt="" />
            </div>
            <div class="main_card-title">
              <span is="i18n">
                <span lang="ru">Контакты</span>
                <span lang="en">Contacts</span>
                <span lang="kk">Байланыстар</span>
              </span>
            </div>
            <div class="main_card-text">
              <span>
                team@kagis.kz, <br />
                +7 7272 588 180
              </span>
            </div>
            <router-link to="/contacts" class="main_card-link">
              <span is="i18n">
                <span lang="ru">Перейти</span>
                <span lang="en">Go</span>
                <span lang="kk">Өту</span>
              </span>
              <i class="icon arrow-right"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style lang="scss">
.geoinformation_solution {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  position: relative;
  margin-bottom: 40px;
}

.geoinformation_solution-text {
  flex-direction: column;
  -ms-flex: 0 0 33%;
  flex: 0 0 33%;
  max-width: 33%;
}

.geoinformation_solution-title {
  color: #00aaff;
  font-size: 38px;
  font-weight: 900;
  width: 450px;
  word-break: break-word;
}

.geoinformation_solution-subtext {
  width: 333px;
  font-size: 20px;
  line-height: 27px;
  color: #555555;
  margin-top: 30px;
  margin-bottom: 30px;
}

.geoinformation_solution-map {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  align-items: center;
  -ms-flex: 0 0 67%;
  flex: 0 0 67%;
  max-width: 67%;
  overflow: hidden;
}

.geoinformation_solution-map > img {
  width: 100%;
  height: auto;
}

.main_cards {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  width: 100%;
  margin-top: 65px;
}

.main_card {
  width: 23%;
  min-height: 350px;
  max-height: 420px;
  height: 100%;
  border: 1px solid #d7d7d7;
  background: #ffffff;
  min-width: 200px;
  margin-left: auto;
  margin-right: auto;
}

.main_card:first-child {
  margin-left: 0 !important;
}

.main_card:last-child {
  margin-right: 0 !important;
}

.main_card-container {
  padding: 40px;
  height: 100%;
  width: 100%;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  flex-direction: column;
}

.main_card-image {
  margin: 0 auto 40px;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  height: 52px;
}

.main_card-title {
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  color: #555555;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.main_card-text {
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  color: #555555;
  margin: 15px auto;
  max-width: 262px;
  min-height: 41px;
}

.main_card-link {
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  width: 80%;
  max-width: 200px;
  height: 40px;
  margin: auto auto 0;
  justify-content: center;
  align-items: center;
  background: #f0f0f0;
  border: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #555555;
}

.main_card-link:hover,
.main_card-link:active {
  background: #dbdbdb;
  transition: all 0.1s;
}

@media (max-width: 1210px) {
  .main_cards {
    margin-top: 40px;
  }
  .main_card {
    width: 40%;
    height: auto;
  }

  .main_card:nth-child(1) {
    margin: 20px 20px 20px auto !important;
  }

  .main_card:nth-child(2) {
    margin: 20px auto 20px 20px !important;
  }

  .main_card:nth-child(3) {
    margin: 20px 20px 20px auto !important;
  }

  .main_card:nth-child(4) {
    margin: 20px auto 20px 20px !important;
  }

  .geoinformation_solution {
    flex-direction: column;
  }
  .geoinformation_solution-text {
    display: -webkit-flex;
    display: -moz-box;
    display: -webkit-flex;
    display: -moz-box;
    display: flex;
    max-width: 100%;
    justify-content: center;
    margin: 0 0 20px;
  }
  .geoinformation_solution-title {
    font-size: 36px;
    width: 60%;
  }
  .geoinformation_solution-map {
    max-width: 100%;
    margin: 20px auto 0;
  }
}

@media (max-width: 576px) {
  .main_card:nth-child(n) {
    height: auto !important;
    max-width: 80%;
    width: 80%;
    margin: 20px auto !important;
  }
  .main_card-container {
    padding: 50px;
  }

  .main_card-link {
    width: 100%;
  }
  .geoinformation_solution-title {
    font-size: 28px !important;
    word-break: normal;
  }
  .geoinformation_solution-subtext {
    font-size: 16px !important;
  }
  .contact_button {
    width: 150px;
    height: 40px;
  }
}
</style>
